const updateApi = (state, action) => {
    if (state === undefined || action?.type === 'RESET') {
        return {
            isInited: undefined,
            user: undefined, //Это точка обмена данными вокруг пользователя. Она для АПИ. Источником истины из жизни пользователей являются недра ветки user из корня редакса
            rights: undefined,
            geoObjs: undefined,
            geoObjReport: undefined,
            geoMultiObjReport: undefined,
            geoObjDashboard: undefined,
            geoObjRoute: undefined,
            geoObjGeozone: undefined,
            getDataGeozoneIntersections: undefined,
            activitiByZone: undefined,
            savingGeoObjGeozone: undefined,
            geoObjReportExcel: undefined,
            geoObjVisits: undefined,
            geoMultiObjReportExcel: undefined,
            workingTimeSheet: undefined,
            directoryList: undefined,
            directoryData: undefined,
            directoryShort: undefined,
            savingDirectory: undefined,
            addingDirectory: undefined,
            deletingDirectory: undefined,
            documentData: undefined,
            singleDocument: undefined,
            singleDocument2: undefined,
            addingDocument: undefined,
            savingDocument: undefined,
            deletingDocument: undefined,
            changingStatusDocument: undefined,
            planWorkDir: undefined,
            planScheduleStatuses: undefined,
            orderWorkStatuses: undefined,
            footerInfo: undefined,
            alarmsInfo: undefined,
        }
    }
    const {api: data} = state;

    switch (action.type) {
        case 'SET_API_INIT_STATUS':
            return {...data, isInited: action.payload};
        case 'SET_API_USER_DATA':
            return {...data, user: action.payload};
        case 'SET_API_USER_RIGHTS':
            return {...data, rights: action.payload};
        case 'SET_API_GEO_OBJECTS':
            return {...data, geoObjs: action.payload};
        case 'SET_API_GEO_OBJECT_REPORT':
            return {...data, geoObjReport: action.payload};
        case 'SET_API_GEO_MULTI_OBJECT_REPORT':
            return {...data, geoMultiObjReport: action.payload};
        case 'SET_API_GEO_OBJECT_DASHBOARD':
            return {...data, geoObjDashboard: action.payload};
        case 'SET_API_GEO_OBJECT_ROUTE':
            return {...data, geoObjRoute: action.payload};
        case 'SET_API_GEO_OBJECT_GEOZONE':
            return {...data, geoObjGeozone: action.payload};
        case 'SET_API_SAVING_GEO_OBJECT_GEOZONE':
            return {...data, savingGeoObjGeozone: action.payload};
        case 'SET_API_SAVING_GEOZONE_INTERSECTIONS':
            return {...data, getDataGeozoneIntersections: action.payload};
        case 'SET_API_ACTIVITI_BY_ZONE':
            return {...data, activitiByZone: action.payload};
        case 'SET_API_GEO_OBJECT_REPORT_EXCEL':
            return {...data, geoObjReportExcel: action.payload};
        case 'SET_API_GEO_OBJECT_VISITS':
            return {...data, geoObjVisits: action.payload};
        case 'SET_API_GEO_MULTI_OBJECT_REPORT_EXCEL':
            return {...data, geoMultiObjReportExcel: action.payload};
        case 'SET_API_WORKING_TIME_SHEET':
            return {...data, workingTimeSheet: action.payload};
        case 'SET_API_DIRECTORY_LIST':
            return {...data, directoryList: action.payload};
        case 'SET_API_DIRECTORY_DATA':
            return {...data, directoryData: action.payload};
        case 'SET_API_DIRECTORY_SHORT':
            return {...data, directoryShort: action.payload};
        case 'SET_API_SAVING_DIRECTORY':
            return {...data, savingDirectory: action.payload};
        case 'SET_API_ADDING_DIRECTORY':
            return {...data, addingDirectory: action.payload};
        case 'SET_API_DELETING_DIRECTORY':
            return {...data, deletingDirectory: action.payload};
        case 'SET_API_DOCUMENT_DATA':
            return {...data, documentData: action.payload};
        case 'SET_API_SINGLE_DOCUMENT':
            return {...data, singleDocument: action.payload};
        case 'SET_API_SINGLE_DOCUMENT2':
            return {...data, singleDocument2: action.payload};
        case 'SET_API_ADDING_DOCUMENT':
            return {...data, addingDocument: action.payload};
        case 'SET_API_SAVING_DOCUMENT':
            return {...data, savingDocument: action.payload};
        case 'SET_API_DELETING_DOCUMENT':
            return {...data, deletingDocument: action.payload};
        case 'SET_API_CHANGING_STATUS_DOCUMENT':
            return {...data, changingStatusDocument: action.payload};
        case 'SET_API_PLAN_WORK_DIR':
            return {...data, planWorkDir: action.payload};
        case 'SET_API_PLAN_SHEDULE_STATUSES':
            return {...data, planScheduleStatuses: action.payload};
        case 'SET_API_ORDER_WORK_STATUSES':
            return {...data, orderWorkStatuses: action.payload};
        case 'SET_API_FOOTER_INFO':
            return {...data, footerInfo: action.payload};
        case 'SET_API_ALARMS_INFO':
            return {...data, alarmsInfo: action.payload};

        default:
            return data;
    }
}

export default updateApi;
